export default "__VITE_PUBLIC_ASSET__a3fef4e6__"